import React, { Component } from 'react';
import TextField from 'material-ui/TextField';

import theme from '../../../muiTheme.js';

class NumericRange extends Component {

  constructor(props) {
    super(props);
    this.state = {
      maxValid: true,
      internalMax: null,
      minValid: true,
      internalMin: null
    };
  }

  maxChanged = (e) => {
    this.changeMax(e.target.value);
  }

  changeMax = (value) => {
    const isEmpty = value === "";
    const max = (isEmpty) ? null : Number.parseFloat(value);
    let maxValid = isEmpty || !Number.isNaN(max);

    //has valid min
    const evaluationMin = (this.state.internalMin) ? this.state.internalMin : this.props.min;
    const minValid = evaluationMin === null || evaluationMin < max;

    if(!isEmpty &&  evaluationMin !== null && !Number.isNaN(evaluationMin) ) {
      maxValid = Boolean(maxValid && (evaluationMin < max));
    }

    let newState = {
      maxValid: maxValid,
      internalMax: (maxValid) ? null : max
    };

    if(!this.state.minValid && maxValid) {
      newState.minValid = minValid;
    }

    this.setState( newState );

    if(maxValid && minValid) {
      this.props.onRangeChange({
        min: evaluationMin,
        max: max
      });
    }
  }

  minChanged = (e) => {
    this.changeMin(e.target.value);
  }

  changeMin = (value) => {
    const isEmpty = value === "";
    const min = (isEmpty) ? null : Number.parseFloat(value);
    let minValid = isEmpty || !Number.isNaN(min);

    //has valid max
    const evaluationMax = (this.state.internalMax) ? this.state.internalMax : this.props.max;
    const maxValid = evaluationMax === null || evaluationMax > min;
    if(!isEmpty &&  evaluationMax !== null && !Number.isNaN(evaluationMax) ) {
      minValid = Boolean(minValid && (evaluationMax > min));
    }



    let newState = {
      minValid: minValid,
      internalMin: (minValid) ? null : min
    };

    if(!this.state.maxValid && minValid) {
      newState.maxValid = maxValid;
    }

    this.setState( newState );

    if(minValid && maxValid ) {
      this.props.onRangeChange({
        max: evaluationMax,
        min: min
      });
    }
  }

  render() {

    const textFileStyle = {
      inputStyle: {
        color: theme.palette.canvasColor
      },
      floatingLabelStyle: {
        color: theme.palette.secondaryTextColor
      },
      floatingLabelFocusStyle: {
        color: theme.palette.canvasColor
      }
    };

    let minTB = (
      <TextField
        value={this.state.minValid ? (this.props.min === null ? "" : this.props.min) : this.state.internalMin}
        floatingLabelText={this.props.minLabel}
        floatingLabelStyle={textFileStyle.floatingLabelStyle}
        floatingLabelFocusStyle={textFileStyle.floatingLabelFocusStyle}
        inputStyle={textFileStyle.inputStyle}
        errorText={ this.state.minValid ? null : "Invalid Value" }
        onChange={this.minChanged}
        />
      )
    let maxTB = (
      <TextField
        value = {this.state.maxValid ? (this.props.max === null ? "" : this.props.max) : this.state.internalMax}
        floatingLabelText={this.props.maxLabel}
        floatingLabelStyle={textFileStyle.floatingLabelStyle}
        floatingLabelFocusStyle={textFileStyle.floatingLabelFocusStyle}
        inputStyle={textFileStyle.inputStyle}
        errorText={ this.state.maxValid ? null : "Invalid Value" }
        onChange={this.maxChanged}
        />
      )



    return (
      <div className="filter-item filter-item-numeric-range">
        {minTB}
        {maxTB}
      </div>
    );
  }

}

export default NumericRange;
